import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { RaisedButton, Snackbar, CircularProgress } from 'material-ui';
import { reduxForm } from 'redux-form';
import { institutionNewField, institutionNewPreviewField } from './InstitutionField';
import { CognitoUserAttribute } from 'amazon-cognito-identity-js';
import Error from '../containers/Error'

class InstitutionCreateForm extends Component {

  attribute = (key, val) => {
    return new CognitoUserAttribute({
      "Name": key,
      "Value": val,
    });
  }

  // プレビュー On/Off.
  handlePreview = (on) => {
    if (on) {
      // 入力チェックして正しくないときは無視.
      if (this.props.invalid) {
        return;
      }
    }

    this.props.institutionActions.preview(on);
  }

  handleSubmit = () => {
    this.props.institutionActions.signUpAndConfirm(
      // アカウントIDとpassword.
      this.props.institutionCreateForm.institution_care_id,
      this.props.institutionCreateForm.password,
      // 配列を渡すことに注意.
      // 必須ではないところでも空文字を入れないといけない.
      [
        { "Name": "email", "Value": this.props.institutionCreateForm.institution_email },
        { "Name": "custom:InstitutionName", "Value": this.props.institutionCreateForm.institution_name },
        { "Name": "custom:InstitutionNameKana", "Value": this.props.institutionCreateForm.institution_name_kana },
        { "Name": "custom:CompanyName", "Value": this.props.institutionCreateForm.company_name },
        { "Name": "custom:CompanyNameKana", "Value": this.props.institutionCreateForm.company_name_kana },
        // ここはサーバ依存なので(本当はinstitutionCareIdにしたいがそのまま)
        { "Name": "custom:InstitutionNumber", "Value": this.props.institutionCreateForm.institution_care_id },
        { "Name": "custom:ApplicationDate", "Value": this.props.institutionCreateForm.application_year_month },
        { "Name": "custom:Tel", "Value": this.props.institutionCreateForm.institution_phone || ''},
        { "Name": "custom:PostCode", "Value": this.props.institutionCreateForm.post_code || '' },
        { "Name": "custom:Address", "Value": this.props.institutionCreateForm.address || '' },
        { "Name": "custom:Fax", "Value": this.props.institutionCreateForm.fax || ''},
        { "Name": "custom:Administrator", "Value": this.props.institutionCreateForm.Administrator || ''},
        { "Name": "custom:ContactPerson", "Value": this.props.institutionCreateForm.ContactPerson || ''},
        { "Name": "custom:iPadCode", "Value": this.props.institutionCreateForm.iPadCode || ''},
      ]
    );
  }

  /**
   * API通信中かどうか（ボタン連打防止の為）.
   *
   * @returns
   * @memberof InstitutionUpdateForm
   */
  isAPICalling() {
    return this.props.institution.SigningUp || this.props.institution.Confirming;
  }

  render() {
    // ローディング.
    if (this.props.institution.Confirming) {
      return (
        <div style={{position: 'relative', margin: 'auto', textAlign: 'center'}}>
          <CircularProgress size={200} thickness={15} />
        </div>
      );
    }

    const wellStyles = {
      formStyle: {maxWidth: 800, margin: '0 auto 10px'},
      buttonStyle: {margin: 12, width:'100px', marginLeft: '340px'},
      buttonLabelStyle: {fontSize: '17px'},
      leftButtonStyle: {margin: 12, marginLeft: '300px'},
      resultButtonStyle: {margin: 12, marginLeft: '250px'},
      messageStyle: {width: '800px'},
    };

    // プレビュー時.
    if (this.props.institution.Previewing) {
      return (
        <form style={wellStyles.formStyle}>
          {institutionNewPreviewField}
          <RaisedButton
            type="button"
            label="戻る"
            disabled={this.isAPICalling()}
            style={wellStyles.leftButtonStyle}
            labelStyle={wellStyles.buttonLabelStyle}
            onClick={() => this.handlePreview(false)}
          />
          <RaisedButton
            type="button"
            label="施設を登録する"
            primary={true} 
            disabled={this.isAPICalling()}
            style={{margin: 12}}
            labelStyle={wellStyles.buttonLabelStyle}
            onClick={() => this.handleSubmit()}
          />
          <br /><br /><br />
        </form>
      )
    } else {
      // 結果時.
      if (this.props.institution.Confirmed === true
        // エラー時はfalse.
        && this.props.institution.result === true) {

        return (
          <form style={wellStyles.formStyle}>
            {institutionNewPreviewField}
            <div>
              <p style={wellStyles.messageStyle}>お客様に上記アカウントとパスワードをお伝えください。</p>
              <br />
              <p>【重要】</p>
              <p style={wellStyles.messageStyle}>この画面を閉じると、二度とこのパスワードが見れなくなります。</p>
              <p style={wellStyles.messageStyle}> 印刷するなどして控えてください。</p>
            </div>
            <RaisedButton
              type="button"
              label="このページを印刷"
              style={wellStyles.resultButtonStyle}
              labelStyle={wellStyles.buttonLabelStyle}
              onClick={() => {window.print();}}
            />
            <br /><br /><br />
            <Snackbar
              message={`${this.props.institutionCreateForm.institution_care_id}が作成されました`}
              open={true}
              autoHideDuration={4000}
              bodyStyle={{ backgroundColor: '#DAEDD2'}}
              contentStyle={{ color: '#356B35' }}
            />
          </form>
        );
      } else {
        // ボタン押下時にもバリデーションさせる仕組み.
        const { handleSubmit } = this.props;

        // デフォルト.
        return (
          <form style={wellStyles.formStyle}>
            {institutionNewField}
            <RaisedButton
              type="button"
              label="登録確認"
              primary={true}
              disabled={this.props.institution.Confirming}
              style={wellStyles.buttonStyle}
              labelStyle={wellStyles.buttonLabelStyle}
              onClick={handleSubmit(() => this.handlePreview(true))}
            />
            <br /><br /><br />
            {
              // API実行されている.
              (this.props.institution.SignedUp === true || this.props.institution.Confirmed === true) && this.props.institution.err ?
                <Error title={'施設情報登録時にエラーが発生しました'} message={this.props.institution.err.message} /> :
                (null)
            }
          </form>
        );
      }
    }
  }
}

InstitutionCreateForm.propTypes = {
  institution: PropTypes.object.isRequired,
  institutionActions: PropTypes.object.isRequired,
  institutionCreateForm: PropTypes.object.isRequired,
};

export default reduxForm({
  form: 'institutionCreateForm'
})(InstitutionCreateForm);



// WEBPACK FOOTER //
// ./src/components/InstitutionCreateForm.js